import { consentRequest } from "./consent.js";

const _BROWSER_GA4_MEASUREMENT_ID = 'G-1YB5SWQ7NP';

let analyticsLoaded = false;
let analyticsRequested = false;
const pendingAnalyticsCommands = [];

function analyticsPush()
{
    if (!analyticsLoaded)
    {
        pendingAnalyticsCommands.push(Array.from(arguments));
        return;
    }
    window.dataLayer.push(arguments);
}

function analyticsSendPage(title, location)
{
    analyticsPush('event', 'page_view',
            {
                page_title: title,
                page_location: location
            });
}

function analyticsInit(sendPageView = true)
{
    if (analyticsRequested) return;
    analyticsRequested = true;

    consentRequest("analytics", () =>
    {
        let script = document.createElement('script');
        script.src = "https://www.googletagmanager.com/gtag/js?id=" + _BROWSER_GA4_MEASUREMENT_ID;
        script.async = true;
        document.head.append(script);

        window.dataLayer = window.dataLayer || [];
        analyticsLoaded = true;
        analyticsPush('js', new Date());
        analyticsPush('config', _BROWSER_GA4_MEASUREMENT_ID, {'send_page_view': sendPageView});
        pendingAnalyticsCommands.splice(0).forEach(command => analyticsPush(...command));
    });
}

export { analyticsInit, analyticsSendPage, analyticsPush };
